module.exports = __webpack_public_path__ + "static/media/3d_assets.b05edf47.zip";